import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '@zz2/zz2-ui';

export default class SyncActions {
    public static setIsLoading = createAction('SYNC_SET_LOADING', withPayloadType<boolean>());
    public static setSyncStatus = createAction('SYNC_SET_STATUS', withPayloadType<boolean>());
}
